import React from 'react';
import { useParams } from 'react-router-dom';

// Components
import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import PropertiesMobileSubnav from './PropertiesMobileSubnav';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionHeader from '../../../_molecules/SectionHeader';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import PropertyDetail from '../../../_organisms/PropertyDetail';
import { DivWithShadowAlternate, SectionWrapperInner, SectionWrapperOuter } from '@styled';

// Functionality
import useProperty from '@hooks/useProperty';
import useDocumentTitle from '@hooks/useDocumentTitle';

const ShowPropertyPage = () => {
    const { id } = useParams();
    const { data: property, loading } = useProperty({ id });
    useDocumentTitle(property?.title ? `Show Property - ${property.title}` : 'Show Property');

    return (
        <ErrorHandler>
            <TrackPageView>
                <PropertiesMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner>
                        <SectionHeader title="My ICSC Properties" />

                        {loading && (
                            <DivWithShadowAlternate className="p-4">
                                <div className="d-flex align-items-center justify-content-center p-4">
                                    <LoadingSpinnerIcon fill="#545454" style={{ marginRight: '10px' }} />
                                </div>
                            </DivWithShadowAlternate>
                        )}

                        {!loading && property && (
                            <>
                                <SectionBreadcrumbs className="mt-2">
                                    <SectionBreadcrumb route="/my-icsc/properties">Properties</SectionBreadcrumb>
                                    <SectionBreadcrumb isActive>{property.title}</SectionBreadcrumb>
                                </SectionBreadcrumbs>

                                <PropertyDetail />
                            </>
                        )}
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default ShowPropertyPage;
